import { useEffect, useState } from 'react';
import { Workday } from '@/api/workday';
import { Input } from '@/components/ui/input';

interface WorkdayIdInputProps {
	row: Workday;
	updateData: Record<string, Workday>;
	stableKey: string;
	handleInputChange: (
		key: string,
		field: keyof Workday,
		value: any,
		row: Workday,
	) => void;
}

const WorkdayInput: React.FC<WorkdayIdInputProps> = ({
	row,
	updateData,
	stableKey,
	handleInputChange,
}) => {
	const [localValue, setLocalValue] = useState(
		updateData[stableKey]?.workdayId ?? row.workdayId ?? '',
	);
	const [isEdited, setIsEdited] = useState<boolean>(false);
	const [error, setError] = useState('');

	useEffect(() => {
		setLocalValue(updateData[stableKey]?.workdayId ?? row.workdayId ?? '');
		setIsEdited(false);
	}, [updateData, stableKey, row.workdayId]);

	const handleLocalChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newValue = e.target.value.trim();
		if (newValue.length > 50) {
			setError('Workday Id cannot exceed 50 characters');
			return;
		}
		setError('');
		setLocalValue(newValue);
		setIsEdited(newValue !== (updateData[stableKey]?.workdayId ?? row.workdayId));
	};
	const handleBlur = () => {
		if (isEdited) {
			handleInputChange(stableKey, 'workdayId', localValue, row);
			setIsEdited(false);
		}
	};
	return (
		<div className="relative">
			<Input
				value={localValue ?? ''}
				onChange={handleLocalChange}
				onBlur={handleBlur}
			/>
			{error && <p className="mt-1 text-sm text-red-500">{error}</p>}
		</div>
	);
};

export default WorkdayInput;
